import { debounceTime, takeUntil } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PlaidInstitutionSearchResult, PlaidService } from '../../../../../services/plaid.service';
import { Organization } from '../../../../../models/entities/organization';
import { OrganizationService } from '../../../../../services/organization/organization.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { SharedModule } from '../../../../shared/shared.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';

export interface PlaidSearchDialogInput
{
    product: 'auth' | 'transactions';
}

export interface PlaidSearchDialogResult
{
    success: boolean;
    selection?: PlaidInstitutionSearchResult;
}

@Component({
    selector: 'lf-plaid-search',
    styleUrls: ['./plaid-search.scss'],
    templateUrl: './plaid-search.component.html',
    standalone: true,
    imports: [
        // Shared
        SharedModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        // Dependencies
    ],
})
export class PlaidSearchComponent implements OnInit
{
    public institutionSearchControl: UntypedFormControl = new UntypedFormControl();
    public institutions: PlaidInstitutionSearchResult[] = [];
    public preferencesLoaded: boolean = false;
    public manualAddEnabled: boolean = false;
    private cancelInFlight = new Subject();

    constructor(
            private _dialogRef: MatDialogRef<PlaidSearchComponent>,
            private _plaidService: PlaidService,
            private _organizationsService: OrganizationService,
            @Inject(MAT_DIALOG_DATA) public data: PlaidSearchDialogInput,
    ) {
    }

    ngOnInit(): void {
        this.institutionSearchControl.valueChanges.pipe(debounceTime(200)).subscribe(
                (searchTerm) => {
                    this.searchInstitutions(searchTerm);
                },
        );
        this.preferencesLoaded = false;
        if (this.data.product === 'auth') {
            this._organizationsService
                    .getOrganizationById(null, ['preferences'])
                    .subscribe(
                            (org: Organization) => {
                                this.preferencesLoaded = true;
                                // is the requests tab is visible
                                this.manualAddEnabled = org.preferences.manualBankAccountAddingEnabled;
                            },
                    );
        }
    }

    public searchInstitutions(searchTerm: string) {
        this.cancelInFlight.next(true);
        if (searchTerm.trim() !== '') {
            this._plaidService.searchInstitutions(searchTerm, this.data.product).pipe(takeUntil(this.cancelInFlight)).subscribe(
                    (data: PlaidInstitutionSearchResult[]) => {
                        this.institutions = data;
                    },
            );
        } else {
            this.institutions = [];
        }
    }

    public closeDialog() {
        this._dialogRef.close(<PlaidSearchDialogResult>{
            success: false,
        });
    }

    public selectInstitution(institution: any) {
        this._dialogRef.close(<PlaidSearchDialogResult>{
            success: true,
            selection: institution,
        });
    }

    //noinspection JSMethodCanBeStatic
    public cancelEvent($event: any) {
        $event.preventDefault();
        $event.stopPropagation();
    }
}
